import { reactive } from 'vue'

// const TYPES = {
//   IMAGE: 'image',
//   VIDEO: 'video',
//   AUDIO: 'audio',
//   DOCUMENT: 'document'
// }

const state = reactive({
  translations: {
    title: '',
    description: '',
    buttonText: '',
    nameText: '',
    sizeText: ''
  },
  imageUrl: '',
  type: '',
  files: [],
  showModal: false,
  created: false
})

export default () => {
  const initializeBlock = (translations) => {
    state.created = true
    if (translations) {
      state.translations = translations
    }
  }
  const setInfo = ({
    type,
    imageUrl,
    files
  }) => {
    state.type = type
    state.imageUrl = imageUrl
    state.files = files
  }
  const setShowModal = (newVal) => {
    state.showModal = newVal
  }

  return {
    state,

    initializeBlock,
    setInfo,
    setShowModal
  }
}
